import { createQueryKeys } from '@lukemorales/query-key-factory';

export const billingQueryKeys = createQueryKeys('billing', {
  subscription: (installationId: number) => [installationId],
});
